export default {
  state: {
    unity: {},
    procedures: [],

    // EXCLUSIVITY
    selectedProcedure: {},
    selectedProcedureUnities: [],
    procedureExclusivityStatus: false,

    // FILTERS
    unitiesFilters: {},
  },

  getters: {
    getUnityData: (state) => state.unity,

    getProcedures: (state) => state.procedures,

    getSelectedProcedure: (state) => state.selectedProcedure,

    getSelectedProcedureUnities: (state) => state.selectedProcedureUnities,

    getProcedureExclusivityStatus: (state) => state.procedureExclusivityStatus,

    getUnitiesFilters: (state) => state.unitiesFilters,
  },

  mutations: {
    setUnityData(state, data) {
      const isUpdate = Object.keys(data).length > 0;

      state.unity = {
        id: isUpdate ? data.id : '',
        cnes: isUpdate ? data.cnes : '',
        name: isUpdate ? data.name : '',
        fantasyName: isUpdate ? data.fantasy_name : '',
        responsible: isUpdate ? data.responsible : '',

        mainPhone: isUpdate ? data.main_phone : '',
        alternativePhone: isUpdate ? data.alternative_phone : '',
        cellPhone: isUpdate ? data.cell_phone : '',
        email: isUpdate ? data.email : '',

        cep: isUpdate ? data.cep : '',
        street: isUpdate ? data.street : '',
        number: isUpdate ? data.number : '',
        district: isUpdate ? data.district : '',
        complement: isUpdate ? data.complement : '',
        county: isUpdate ? data.county : '',
        healthRegionId: isUpdate ? parseInt(data.healthRegion_id) : '',
        macroRegionId: isUpdate ? parseInt(data.macroRegion_id) : '',
        uf: isUpdate ? data.uf : '',

        administrativeSphereId: isUpdate ? data.administrativeSphere.id : '',
        natureOrganizationId: isUpdate ? data.natureOrganization.id : '',
        typeUnityId: isUpdate ? data.typeUnity.id : '',
        procedureGroup: isUpdate
          ? data.groupProcedures.map((item) => item.id)
          : [],
        accreditationId: isUpdate
          ? data.accreditation
            ? data.accreditation.id
            : ''
          : '',
        lat: isUpdate ? data.lat : '',
        lon: isUpdate ? data.lon : '',

        integrationAGHUse: isUpdate
          ? data.integrationAGHUse === 'SIM'
            ? true
            : false
          : false,
        codeAGHUse: isUpdate ? data.code_AGHUse : '',
        coverage: isUpdate ? data.coverage : [],

        ppp: isUpdate ? (data.flag_ppp_image === 'SIM' ? true : false) : false,
        egress: isUpdate ? (data.flag_egress === 'SIM' ? true : false) : false,
        unacon: isUpdate
          ? data.flag_oncology === 'SIM'
            ? true
            : false
          : false,
        flag_eletive: isUpdate
          ? data.flag_eletive === 'SIM'
            ? true
            : false
          : false,
        flag_ambulatory: isUpdate
          ? data.flag_ambulatory === 'SIM'
            ? true
            : false
          : false,
        procedureOccupation: isUpdate ? data.unityOcupationProcedures : [],
        ambulatoryResevedProcedures: isUpdate
          ? data.ambulatoryResevedProcedures
          : [],
        pppImageResevedProcedures: isUpdate
          ? data.pppImageResevedProcedures
          : [],

        egressResevedProcedures: isUpdate ? data.egressResevedProcedures : [],
        oncologyResevedProcedures: isUpdate
          ? data.oncologyResevedProcedures
          : [],
        procedureUnities: isUpdate ? data.procedureUnities : [],
        districtsData: isUpdate
          ? data.district_external_code.map((item) => {
              return {
                id: parseInt(item),
              };
            })
          : [],
        groupProcedures: isUpdate ? data.groupProcedures : [],
        egresses: isUpdate ? data.unityOcupationProceduresEgress : [],
        oncology: isUpdate ? data.unityOcupationProcedureUnaconOncologys : [],
        unityOcupationProcedureEletive: isUpdate
          ? data.unityOcupationProcedureEletive
          : [],

        isUpdate: isUpdate,
      };
    },

    setProcedures(state, procedures) {
      state.procedures = procedures;
    },

    setUpdateProcedures(state, data) {
      state.unity.procedureOccupation = data;
    },

    setUpdateEgressProcedures(state, data) {
      state.unity.egresses = data;
    },

    setUpdateUnaconProcedures(state, data) {
      state.unity.oncology = data;
    },

    setUpdateElectiveProcedures(state, data) {
      state.unity.unityOcupationProcedureEletive = data;
    },

    setSelectedProcure(state, procedure) {
      state.selectedProcedure = procedure;
    },

    setSelectedProcedureUnities(state, unities) {
      state.selectedProcedureUnities = unities;
    },

    setProcedureExclusivityStatus(state, status) {
      state.procedureExclusivityStatus = status;

      if (!state.procedureExclusivityStatus) {
        state.selectedProcedureUnities = [];
      }
    },

    setUnitiesFilters(state, filters) {
      state.unitiesFilters = filters;
    },
  },

  actions: {
    changeUnityData(context, data) {
      context.commit('setUnityData', data);
    },

    changeProcedures(context, procedures) {
      context.commit('setProcedures', procedures);
    },

    changeDataProcedureOccupationData(context, data) {
      context.commit('setUpdateProcedures', data);
    },

    changeDataEgressProcedureOccupationData(context, data) {
      context.commit('setUpdateEgressProcedures', data);
    },

    changeDataUnaconProcedureOccupationData(context, data) {
      context.commit('setUpdateUnaconProcedures', data);
    },

    changeDataElectiveProcedureOccupationData(context, data) {
      context.commit('setUpdateElectiveProcedures', data);
    },

    changeSelectedProcedure(context, procedure) {
      context.commit('setSelectedProcure', procedure);
    },

    changeSelectedProcedureUnities(context, unities) {
      context.commit('setSelectedProcedureUnities', unities);
    },

    changeProcedureExclusivityStatus(context, status) {
      context.commit('setProcedureExclusivityStatus', status);
    },

    changeUnitiesFilters(context, filters) {
      context.commit('setUnitiesFilters', filters);
    },
  },
};
